import { useState, useEffect } from "react";
import { fetchLinkTargets, applyAutoLinks } from "@/lib/autoLinker";

export function useAutoLinker(
  content: string | null,
  currentArticleSlug?: string
): { linkedContent: string | null; isProcessing: boolean } {
  const [linkedContent, setLinkedContent] = useState<string | null>(content);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (!content) {
      setLinkedContent(null);
      return;
    }

    let cancelled = false;
    setIsProcessing(true);

    (async () => {
      try {
        const targets = await fetchLinkTargets();
        if (!cancelled) {
          const processed = applyAutoLinks(content, targets, currentArticleSlug);
          setLinkedContent(processed);
        }
      } catch (error) {
        console.error("Auto-linking failed:", error);
        if (!cancelled) {
          setLinkedContent(content); // Fallback to original content
        }
      } finally {
        if (!cancelled) {
          setIsProcessing(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [content, currentArticleSlug]);

  return { linkedContent, isProcessing };
}
